import axios from 'axios';

const AUTH_LOGIN_PATH = /(?:^|\/)auth\/(?:admin\/)?login(?:[/?#]|$)/;
const AUTH_REFRESH_PATH = /(?:^|\/)auth\/refresh(?:[/?#]|$)/;

export function isAuthLoginUrl(url: unknown): boolean {
  return typeof url === 'string' && AUTH_LOGIN_PATH.test(url);
}

export function isExpectedLoginResponse(url: unknown, status: unknown): boolean {
  return isAuthLoginUrl(url) && (status === 400 || status === 401);
}

export function isAuthRefreshUrl(url: unknown): boolean {
  return typeof url === 'string' && AUTH_REFRESH_PATH.test(url);
}

/**
 * A failed session refresh is an expected auth-lifecycle outcome, not an API
 * defect: the session simply cannot be renewed, so the user is (still) not
 * signed in. The caller decides what to do (bootstrap stays a guest, the retry
 * path logs out); the interceptor must stay silent — no error log, no toast.
 */
export function isExpectedRefreshResponse(url: unknown, status: unknown): boolean {
  return isAuthRefreshUrl(url) && (status === 401 || status === 403);
}

export function getApiErrorStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}

export function getApiErrorDetail(error: unknown): string | undefined {
  if (!axios.isAxiosError(error)) return undefined;
  const data: unknown = error.response?.data;
  if (typeof data !== 'object' || data === null || !('detail' in data)) return undefined;
  return typeof data.detail === 'string' ? data.detail : undefined;
}

export function isExpectedLoginError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false;
  return isExpectedLoginResponse(error.config?.url, error.response?.status);
}
